import Flags from "flags";
export const APPARATUS_MODULES = ["chemistry", "heating", "various", "shapes", "biology", "physics", "distillation", "measurement", "transport"];
export const moduleDisplayIcon = (module) => {
    switch (module) {
        case "chemistry":
            return "flask";
        case "various":
            return "box-open";
        case "shapes":
            return "shapes";
        case "physics":
            return "atom";
        case "biology":
            return "leaf";
        case "distillation":
            return "tint";
        case "measurement":
            return "ruler";
        case "heating":
            return "flame";
        case "transport":
            return "pipe-section";
    }
};
/** List all categories, in the desired order. */
export const apparatusCategories = {
    "chemistry": [
        "Containers",
        "Filtering",
        "Metallic",
        "Ceramic",
        "Devices",
        "Chromatography",
        "Storage",
    ],
    "biology": [
        "_Bio_Equipment",
        "Organic",
        "_Bio_Other",
    ],
    "physics": [
        "Electric & Magnetic",
        ...(Flags.isElectricalSymbolsEnabled ? ["Electrical symbols"] : []),
        "Optics",
        "Dynamics",
    ],
    "heating": [
        "Heating",
    ],
    "measurement": [
        "Measurement",
        "_Mea_Extraction",
    ],
    "transport": [
        "Tubes",
    ],
    "distillation": [
        "Condensers",
        "Distillation",
    ],
    "various": [
        "Substances",
        "Labelling",
        "Medical",
        "Accessories",
    ],
    "shapes": [
        "Basic shapes",
        "Arrows",
        "3D",
    ],
};
export const categoryToModuleMap = {};
for (const module of APPARATUS_MODULES) {
    for (const category of apparatusCategories[module]) {
        categoryToModuleMap[category] = module;
    }
}
